import { HANDLE_WIDTH } from './segmented-range-selector.constants';
import { RangeType } from './segmented-range-selector.types';

export function relativeToNumMax(
  relativeValue: number,
  globalRange: RangeType
): number {
  const value = (globalRange.max - globalRange.min) * (relativeValue / 100);

  return globalRange.min + value;
}

export function maxValueToXPos(containerWidth: number, segmentMax?: number) {
  if (segmentMax === undefined) {
    return 0;
  }

  return containerWidth * (segmentMax / 100);
}

export function xPosToMaxValue(xPosition: number, containerWidth: number) {
  return (xPosition / containerWidth) * 100;
}

export function computeDragLimit(
  containerWidth: number,
  segmentMaxToTheLeft: number,
  segmentMaxToTheRight: number,
  offset: number = HANDLE_WIDTH / 2
) {
  const min = maxValueToXPos(containerWidth, segmentMaxToTheLeft || 0);
  const max = maxValueToXPos(
    containerWidth,
    segmentMaxToTheRight || containerWidth
  );

  return { left: min - offset, right: max - offset };
}
